// Copyright (C) 2024 Skylark Drones

export const PUSHER_KEY = process.env.VUE_APP_PUSHER_KEY
export const PUSHER_CLUSTER = process.env.VUE_APP_PUSHER_CLUSTER

export const RTC_EVENTS = {
  droneState: 'client-drone-state'
}
